import { CustomizationDeliveryScreen } from '../../../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <CustomizationDeliveryScreen />;
}
